<main class="container-geral d-flex flex-column gap-4">
  <section class="cabecalho">
      <h1 class="titulo">{{ "COMPONENTS.METAS.form.titleCreate" | transloco }}</h1>
  </section>

  <section class="form-section">
      <p class="paragrafo-informacoes">{{ "COMPONENTS.METAS.form.info" | transloco }}</p>

      <div class="formulario">
          <form [formGroup]="formularioMeta" class="group-form" class="group-form" (keydown.enter)="$event.preventDefault()">
              <div class="row">
                <div class="col-md-12 mb-4">
                  <label class="form-label">{{ "COMPONENTS.METAS.form.nameLabel" | transloco }}</label>

                  <input formControlName="vc_nome" class="input-form form-control"
                  [class.invalido]="validarCampoInvalido(formularioMeta.get('vc_nome'))"
                    [placeholder]="'COMPONENTS.METAS.form.namePlaceholder' | transloco" />

                    <small *ngIf="validarCampoInvalido(formularioMeta.get('vc_nome'))" class="mensagem-validacao-form">
                      {{ "COMPONENTS.METAS.form.nameRequired" | transloco }}
                    </small>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-4">
                  <label class="form-label">{{ "COMPONENTS.METAS.form.goalLabel" | transloco }}</label>

                  <input formControlName="fl_meta_total" type="number" class="input-form form-control"
                    [class.invalido]="validarCampoInvalido(formularioMeta.get('fl_meta_total'))"
                    [placeholder]="'COMPONENTS.METAS.form.goalPlaceholder' | transloco" />

                    <small *ngIf="validarCampoInvalido(formularioMeta.get('fl_meta_total'))" class="mensagem-validacao-form">
                      {{ "COMPONENTS.METAS.form.goalRequired" | transloco }}
                    </small>
                </div>

                <div class="col-md-6 mb-4">
                  <label class="form-label">{{ "COMPONENTS.METAS.form.plantLabel" | transloco }}</label>

                  <select formControlName="fk_cliente" class="crud-select form-select input-form">
                    <option value="" selected disabled>{{ placeholderClientes | transloco }}</option>

                    @for (cliente of clientes; track cliente.id) {
                      <option [value]="cliente.id">
                        {{ cliente.nome }}
                      </option>
                    }
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-4">
                  <label class="form-label">{{ "COMPONENTS.METAS.form.startDateLabel" | transloco }}</label>

                  <input formControlName="dt_inicio_meta" type="date" class="input-form form-control"
                    [class.invalido]="validarCampoInvalido(formularioMeta.get('dt_inicio_meta'))" />

                    <small *ngIf="validarCampoInvalido(formularioMeta.get('dt_inicio_meta'))" class="mensagem-validacao-form">
                      {{ "COMPONENTS.METAS.form.startDateRequired" | transloco }}
                    </small>
                </div>

                <div class="col-md-6 mb-4">
                  <label class="form-label">{{ "COMPONENTS.METAS.form.endDateLabel" | transloco }}</label>

                  <input formControlName="dt_fim_meta" type="date" class="input-form form-control"
                    [class.invalido]="validarCampoInvalido(formularioMeta.get('dt_fim_meta'))" />

                    <small *ngIf="validarCampoInvalido(formularioMeta.get('dt_fim_meta'))" class="mensagem-validacao-form">
                      {{ "COMPONENTS.METAS.form.endDateRequired" | transloco }}
                    </small>
                    <small *ngIf="formularioMeta.errors?.['datasInvalidas']" class="mensagem-validacao-form">
                      {{ "COMPONENTS.METAS.form.endDateInvalid" | transloco }}
                    </small>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div >
                    <label class="form-label">{{ "COMPONENTS.METAS.form.workSevenDaysLabel" | transloco }}</label>
                    <div class="row">
                      <div class="col-6 ">
                          <button mat-raised-button class="w-100 btn botao botao-sim" [class.botao-sim-selecionado]="trabalhaSeteDias"
                          (click)="verificaTrabalhaSeteDias(true)" type="button">
                              {{ "COMPONENTS.METAS.form.yes" | transloco }}
                          </button>
                      </div>
                      <div class="col-6 ">
                        <button mat-raised-button class="w-100 btn botao botao-nao" [class.botao-nao-selecionado]="!trabalhaSeteDias"
                        (click)="verificaTrabalhaSeteDias(false)"type="button">
                            {{ "COMPONENTS.METAS.form.no" | transloco }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                @if(!trabalhaSeteDias){
                  <div class="col-md-6">
                    <label class="form-label">{{ "COMPONENTS.METAS.form.workDaysLabel" | transloco }}</label>

                    <input id="input-dias" formControlName="it_dias_trabalhados_semana"
                    class="input-form form-control"
                    [class.invalido]="validarCampoInvalido(formularioMeta.get('it_dias_trabalhados_semana'))"
                    type="number" min="1" max="7" />

                      <small *ngIf="validarCampoInvalido(formularioMeta.get('it_dias_trabalhados_semana'))" class="mensagem-validacao-form">
                        {{ "COMPONENTS.METAS.form.workDaysRequired" | transloco }}
                      </small>
                  </div>
                }
              </div>


              <div class="buttons-form d-flex">
                <button class="btn-cancelar" (click)="cancelar()">
                  <object class="me-2" data="assets/icone-fechar.svg" type="image/svg+xml"></object>
                  {{ "COMPONENTS.METAS.form.cancelButton" | transloco }}
                </button>

                <button
                  [disabled]="botaoDesabilitado"
                  [class.btn-confirmar-desabilitado]="botaoDesabilitado"
                  class="btn-confirmar" (click)="onSubmit()">
                  @if (loadingBotao) {

                    <div class="spinner-border text-white spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                  }
                  @else{ {{ "COMPONENTS.METAS.form.submitButton" | transloco }} }

                </button>
              </div>
          </form>
      </div>
  </section>
</main>
